module.exports = __webpack_public_path__ + "img/defaultVoucherIco.f19aaad3.png";